export class MoleculePanelServiceObjectSslComponent {
    public templateUrl = require('./panel-service-object-ssl.html?external');
}
